import { render } from "./SkeletonLoader.vue?vue&type=template&id=ed241e6e&scoped=true&ts=true"
import script from "./SkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./SkeletonLoader.vue?vue&type=script&lang=ts"

import "./SkeletonLoader.vue?vue&type=style&index=0&id=ed241e6e&scoped=true&lang=scss"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed241e6e"]])

export default __exports__